var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP4PolygonRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 123,
    viewBox: "0 0 126 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.617 131.618L0.48633 126.147L126.146 0.487565L131.617 131.618Z",
    fill: "#880E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP4PolygonRight);
export default __webpack_public_path__ + "static/media/Digital_P4_Polygon_Right.443cd2e2a702c9d45eae06a213ab66d5.svg";
export { ForwardRef as ReactComponent };